import { render } from "./ListeHistoriquePage.vue?vue&type=template&id=708dbca1&ts=true"
import script from "./ListeHistoriquePage.vue?vue&type=script&lang=ts"
export * from "./ListeHistoriquePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__